<template>
  <div class="page-content">
    <div class="container py-3">
      <div class="row mb-4 justify-content-center">
        <div class="col-lg-7 text-center">
          <a @click="$router.go(-1)" class="float-start cursor-pointer">
            <svg
              width="12"
              height="16"
              viewBox="0 0 8 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.40059 10.7993L1.60059 5.99932L6.40059 1.19932"
                stroke="#001D21"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
          <h1 class="page-title">Notifications</h1>
        </div>
      </div>
      <div>
        <div class="row justify-content-center">
          <div class="col-lg-7 mb-3">
            <div class="card p-3 rounded-4 cursor-pointer mb-3">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex gap-3">
                  <svg
                    width="20"
                    height="22"
                    viewBox="0 0 18 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.2735 15.0668H16.7275C17.1569 15.0668 17.4004 14.4373 17.1475 14.0765C16.5621 13.2413 15.9933 12.01 15.9933 10.5253L16.0185 8.49437C16.0185 4.46591 12.8762 1.2002 9 1.2002C5.18005 1.2002 2.08337 4.4185 2.08337 8.38848L2.05819 10.5253C2.05819 11.9999 1.46915 13.2245 0.858873 14.0594C0.595869 14.4192 0.83871 15.0668 1.2735 15.0668Z"
                      fill="#DEE9EA"
                    />
                    <path
                      d="M6.25 17.9113C6.97979 18.4641 7.94351 18.8002 9 18.8002C10.0565 18.8002 11.0202 18.4641 11.75 17.9113M1.2735 15.0668C0.83871 15.0668 0.595869 14.4192 0.858873 14.0594C1.46915 13.2245 2.05819 11.9999 2.05819 10.5253L2.08337 8.38848C2.08337 4.4185 5.18005 1.2002 9 1.2002C12.8762 1.2002 16.0185 4.46591 16.0185 8.49437L15.9933 10.5253C15.9933 12.01 16.5621 13.2413 17.1475 14.0765C17.4004 14.4373 17.1569 15.0668 16.7275 15.0668H1.2735Z"
                      stroke="#004852"
                      stroke-width="1.3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <div>
                    <h3 class="font-14 font-medium mb-1">Push Notification</h3>
                    <p class="mb-0 text-secondary font-12">
                      Get notifications about information related to order
                      status, garages and services offers.
                    </p>
                  </div>
                </div>
                <div class="form-check font-18">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="notificationObj.is_notification"
                    id="PushNotification"
                    true-value="Y"
                    false-value="N"
                  />
                  <label
                    class="form-check-label"
                    for="PushNotification"
                  ></label>
                </div>
              </div>
            </div>

            <div class="card p-3 rounded-4 cursor-pointer">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex gap-3">
                  <svg
                    width="21"
                    height="22"
                    viewBox="0 0 21 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.693 19.1985C7.099 20.025 8.7425 20.5 10.5 20.5C15.744 20.5 20 16.244 20 11C20 5.756 15.744 1.5 10.5 1.5C5.256 1.5 1 5.756 1 11C1 12.729 1.46553 14.3535 2.27303 15.75L1 20.5L5.693 19.1985Z"
                      fill="#DEE9EA"
                      stroke="#004852"
                      stroke-width="1.3"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.25 14.0115C15.25 14.1825 15.212 14.3629 15.1265 14.5339C15.041 14.7049 14.9365 14.8665 14.8035 15.0185C14.566 15.275 14.3095 15.465 14.0245 15.579C13.7395 15.7025 13.426 15.7595 13.0935 15.7595C12.609 15.7595 12.0865 15.6455 11.545 15.408C10.994 15.1705 10.4525 14.8569 9.911 14.4674C9.36 14.0684 8.84699 13.6219 8.35299 13.1374C7.85899 12.6434 7.42203 12.1209 7.02303 11.5794C6.63353 11.0379 6.31999 10.4964 6.09199 9.95494C5.86399 9.41344 5.75 8.89096 5.75 8.39696C5.75 8.07396 5.80699 7.76045 5.92099 7.47545C6.03499 7.18095 6.21551 6.91496 6.47201 6.67746C6.77601 6.37346 7.10849 6.23096 7.45999 6.23096C7.59299 6.23096 7.72602 6.25945 7.84952 6.31645C7.97302 6.37345 8.08699 6.45895 8.17249 6.58245L9.27452 8.14044C9.36002 8.26394 9.42647 8.36844 9.46447 8.47294C9.51197 8.57744 9.53098 8.67244 9.53098 8.76744C9.53098 8.88144 9.493 8.99546 9.4265 9.10946C9.36 9.22346 9.27453 9.33744 9.16053 9.45144L8.79952 9.83144C8.74252 9.88844 8.7235 9.94545 8.7235 10.0214C8.7235 10.0594 8.73302 10.0974 8.74252 10.1354C8.76152 10.1734 8.771 10.2019 8.7805 10.2304C8.866 10.3919 9.01797 10.5914 9.22697 10.8384C9.44547 11.0854 9.67351 11.3419 9.92051 11.5889C10.177 11.8454 10.424 12.0734 10.6805 12.2919C10.9275 12.5009 11.1365 12.6435 11.298 12.729C11.3265 12.7385 11.355 12.7574 11.3835 12.7669C11.4215 12.7859 11.4595 12.786 11.507 12.786C11.5925 12.786 11.6495 12.7575 11.7065 12.7005L12.0675 12.3394C12.191 12.216 12.305 12.1305 12.4095 12.0735C12.5235 12.007 12.628 11.9689 12.7515 11.9689C12.8465 11.9689 12.9415 11.9879 13.046 12.0354C13.1505 12.0829 13.2645 12.14 13.3785 12.2255L14.9555 13.3464C15.079 13.4319 15.1645 13.5365 15.2215 13.6505C15.2215 13.7645 15.25 13.8785 15.25 14.0115Z"
                      fill="white"
                      stroke="#004852"
                      stroke-width="1.3"
                      stroke-miterlimit="10"
                    />
                  </svg>
                  <div>
                    <h3 class="font-14 font-medium mb-1">
                      WhatsApp Notifications
                    </h3>
                    <p class="mb-0 text-secondary font-12">
                      You might miss the updates, keep this on for seamless
                      process.
                    </p>
                  </div>
                </div>
                <div class="form-check font-18">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="notificationObj.is_whatsapp_notification"
                    id="WhatsApp"
                    true-value="Y"
                    false-value="N"
                  />
                  <label class="form-check-label" for="WhatsApp"></label>
                </div>
              </div>
            </div>
          </div>
          <ErrorComponent ref="errorComponent"></ErrorComponent>
        </div>
        <div class="text-center">
          <button
            id="save-notification"
            type="button"
            class="btn btn-primary"
            v-on:click="saveNotification"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer  -->
  <!-- <footer class="footer">
    <div class="container">
    <div class="row">
        <div class="col-lg-6 text-lg-start text-center ">  <div class="font-14">Copyright (c) 2014, Youhonk. All rights reserved.</div> </div>
        <div class="col-lg-6 text-lg-end text-center">
          <a href="" class="text-brand me-3"> Privacy Policy </a>
          <a href="" class="text-brand "> Terms of Service </a>
        </div>
    </div>
  </div>
  </footer> -->
</template>
<script>
import ErrorComponent from '@/components/ErrorComponent.vue';

// import "./onboarding.scss";
export default {
  name: "NotificationPage",
  components: {
    ErrorComponent
  },

  data() {
    return {
      workshop_id: "",
      notificationObj: {},
    };
  },

  mounted() {
    if (this.page_type == "ADD_OUTLET") {
      this.workshop_id = localStorage.getItem("outlet_workshop_id");
    } else {
      this.workshop_id = localStorage.getItem("workshop_id");
    }
    if (this.workshop_id) {
      this.getNotificationList();
    }
  },
  methods: {
    getNotificationList() {
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.showLoader(true);
      }
      this.$api
        .getAPI({
          _action: "get-notification-setting/" + this.workshop_id,
          _hide_loader: true,
        })
        .then((res) => {
          if (res && res.info) {
            this.notificationObj = res.info;
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.showLoader(false);
          }
        })
        .catch(() => {
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.showLoader(false);
          }
        });
    },
    saveNotification() {
      if (this.workshop_id) {
        var obj = {};
        obj.is_notification = this.notificationObj.is_notification
          ? this.notificationObj.is_notification
          : "N";
        obj.is_whatsapp_notification = this.notificationObj
          .is_whatsapp_notification
          ? this.notificationObj.is_whatsapp_notification
          : "N";
        this.$api
          .postAPI({
            _action: "/set-notification-setting/" + this.workshop_id,
            _body: obj,
            _buttonId: "save-notification",
          })
          .then((res) => {
            this.$toast.open({
              message: res.message,
              type: "success",
              duration: 3000,
              position: "top-right",
            });
            this.$router.push("/settings")
          })
          .catch((error) => {
            console.log(error);
            this.$toast.open({
              message: "Error",
              type: "error",
              duration: 3000,
              position: "top-right",
            });
          });
      }
    },
  },
};
</script>
